module.exports = __webpack_public_path__ + "static/media/empty.5254ba69.svg";